// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"2fdd1dd9","587":"1545c720","899":"a8b6e308"}[chunkId] + ".js";
};